import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getBreachTypeOfEvidenceList as getBreachTypeOfEvidenceListApi,
	getBreachTypeOfEvidenceListQuery as getBreachTypeOfEvidenceListQueryApi,
	getBreachTypeOfEvidenceById as getBreachTypeOfEvidenceByIdApi,
	addNewBreachTypeOfEvidenceApi,
	updateBreachTypeOfEvidenceApi,
	deleteBreachTypeOfEvidenceApi,
	checkBreachTypeOfEvidenceExistsApi,
} from '../../helpers/breach_type_of_evidence/api_helper';

export const getBreachTypeOfEvidenceList = createAsyncThunk(
	'breachTypeOfEvidence/getBreachTypeOfEvidenceList',
	async params => {
		try {
			const response = await getBreachTypeOfEvidenceListApi(params);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener tipos de evidencia.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const getBreachTypeOfEvidenceListQuery = createAsyncThunk(
	'breachTypeOfEvidence/getBreachTypeOfEvidenceListQuery',
	async params => {
		try {
			const response = getBreachTypeOfEvidenceListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getBreachTypeOfEvidence = createAsyncThunk(
	'breachTypeOfEvidence/getBreachTypeOfEvidence',
	async id => {
		try {
			const response = await getBreachTypeOfEvidenceByIdApi(id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el tipo de evidencia.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const addNewBreachTypeOfEvidence = createAsyncThunk(
	'breachTypeOfEvidence/addNewBreachTypeOfEvidence',
	async breachTypeOfEvidence => {
		try {
			const response = await addNewBreachTypeOfEvidenceApi(breachTypeOfEvidence);
			toast.success('Tipo de Evidencia agregado exitosamente.', { autoClose: 3000 });
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el tipo de evidencia.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateBreachTypeOfEvidence = createAsyncThunk(
	'breachTypeOfEvidence/updateBreachTypeOfEvidence',
	async breachTypeOfEvidence => {
		try {
			const response = await updateBreachTypeOfEvidenceApi(breachTypeOfEvidence);
			toast.success('Tipo de Evidencia actualizado exitosamente.', { autoClose: 3000 });
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el tipo de evidencia.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteBreachTypeOfEvidence = createAsyncThunk(
	'breachTypeOfEvidence/deleteBreachTypeOfEvidence',
	async breachTypeOfEvidence => {
		try {
			await deleteBreachTypeOfEvidenceApi(breachTypeOfEvidence._id);
			toast.success('Tipo de Evidencia eliminado exitosamente.', { autoClose: 3000 });
			return breachTypeOfEvidence;
		} catch (error) {
			toast.error('Error al eliminar el tipo de evidencia.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const checkBreachTypeOfEvidenceExists = createAsyncThunk(
	'breachTypeOfEvidence/checkBreachTypeOfEvidenceExists',
	async name => {
		try {
			const response = await checkBreachTypeOfEvidenceExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
